export default "__VITE_ASSET__e6a688ac__"